import React from "react";
import AdminDetailsContainer from "../../modules/Admins/containers/AdminDetailsContainer/AdminDetailsContainer";

const AdminDetails = () => {
  return <AdminDetailsContainer />;
};

export default AdminDetails;
